import React, { useState, useRef, useEffect } from "react";
import "../styles/customDropdown.css"; // styles for animation + layout
import userArrow from '../assets/images/user_arrow.svg';

const CustomDropdown = ({ options = [], selectedValue, onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="dropdown-wrapper" ref={dropdownRef}>
            <button
                className={`dropdown-btn ${isOpen ? "active" : ""}`}
                onClick={() => setIsOpen(!isOpen)}
                type="button"
            >
                {selectedValue || "Select"}
                <span className="arrow">
                    <img src={userArrow} alt="arrow" />
                </span>
            </button>

            <div className={`dropdown-list ${isOpen ? "show" : ""}`}>
                {options.length > 0 ? (
                    options.map((opt) => (
                        <div
                            key={opt.value}
                            className="item-list"
                            onClick={() => {
                                onSelect(opt.value);
                                setIsOpen(false);
                            }}
                        >
                            {opt.label}
                        </div>
                    ))
                ) : (
                    <div className="dropdown-item no-option">No options available</div>
                )}
            </div>
        </div>
    );
};

export default CustomDropdown;
